import { clsx } from 'clsx';
import { Children, FC, ReactNode } from 'react';

import * as styles from './WrapElementsSpacer.css';

type Space = 0 | 2 | 4 | 8 | 12 | 16;

type WrapElementsSpacerProps = {
  children: Array<ReactNode> | ReactNode;
  verticalSpace: Space;
  horizontalSpace: Space;
  containerTestId?: string;
  /** @default true */
  wrapItems?: boolean;
};

const addPx = (num: number): string => `${num}px`;

export const WrapElementsSpacer: FC<WrapElementsSpacerProps> = props => {
  const { children, verticalSpace, horizontalSpace, containerTestId, wrapItems = true } = props;

  const realVerticalSpace = verticalSpace / 2;
  const realHorizontalSpace = horizontalSpace / 2;

  const childStyle = { padding: `${addPx(realVerticalSpace)} ${addPx(realHorizontalSpace)}` };
  const containerStyle = { margin: `${addPx(-realVerticalSpace)} ${addPx(-realHorizontalSpace)}` };

  const childrenArrWithWrapper = Array.of<JSX.Element>();
  Children.forEach(children, (child, index) => {
    if (
      child != null &&
      child !== '' &&
      (typeof child === 'number' || typeof child === 'string' || typeof child === 'object')
    ) {
      childrenArrWithWrapper.push(
        <div className={styles['item']} data-testid={`${containerTestId}-item-${index}`} key={index} style={childStyle}>
          {child}
        </div>,
      );
    }
  });

  if (!childrenArrWithWrapper.length) {
    return null;
  }

  return (
    <div
      className={clsx(styles['container'], wrapItems ? styles['wrap'] : styles['nowrap'])}
      data-testid={containerTestId}
      style={containerStyle}
    >
      {childrenArrWithWrapper}
    </div>
  );
};
